import { Link } from "react-router-dom"
import { UrlPath } from "utility/routes"

const NoCompany = () => {
  return (
    <div className="card">
      <div className="card-body">
        <h1 className="h3">Endre bedriftsopplysninger</h1>
        <p><span className="fw-medium">Vi kan ikke finne bedrifter knyttet til ditt navn eller telefonnummer, men du kan likevel endre opplysninger for en bedrift hvis du har tillatelse til dette.</span></p>
        <p className="text-secondary">Legg til din bedrift, gjør endringer og lagre informasjonen så vil en av våre kundekonsulenter manuelt godkjenne endringene du har gjort.</p>
        <p className="text-secondary">Du vil motta en e-post når endringene er godkjent og publisert til våre nettsider.</p>
        <p className="mt-4 mb-0">
          <Link to={UrlPath.MyAccount.AddCompany} className="btn btn-primary">
            <i className="bi bi-plus-lg"></i> Legg til bedrift
          </Link>
        </p>    
      </div> 
    </div>
  )
}

export default NoCompany